export default __webpack_public_path__ + "static/media/Minicard_5s.8be44946.svg";